/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListRiskResultsByChatRequest,
  ListRiskResultsByChatSecurity,
} from "../models/operations/listriskresultsbychat.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildRiskListResultsByChatQuery,
  prefetchRiskListResultsByChat,
  queryKeyRiskListResultsByChat,
  RiskListResultsByChatQueryData,
} from "./riskListResultsByChat.core.js";
export {
  buildRiskListResultsByChatQuery,
  prefetchRiskListResultsByChat,
  queryKeyRiskListResultsByChat,
  type RiskListResultsByChatQueryData,
};

export type RiskListResultsByChatQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listRiskResultsByChat risk
 *
 * @remarks
 * List risk results grouped by chat session for the current project.
 */
export function useRiskListResultsByChat(
  request?: ListRiskResultsByChatRequest | undefined,
  security?: ListRiskResultsByChatSecurity | undefined,
  options?: QueryHookOptions<
    RiskListResultsByChatQueryData,
    RiskListResultsByChatQueryError
  >,
): UseQueryResult<
  RiskListResultsByChatQueryData,
  RiskListResultsByChatQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildRiskListResultsByChatQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listRiskResultsByChat risk
 *
 * @remarks
 * List risk results grouped by chat session for the current project.
 */
export function useRiskListResultsByChatSuspense(
  request?: ListRiskResultsByChatRequest | undefined,
  security?: ListRiskResultsByChatSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    RiskListResultsByChatQueryData,
    RiskListResultsByChatQueryError
  >,
): UseSuspenseQueryResult<
  RiskListResultsByChatQueryData,
  RiskListResultsByChatQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildRiskListResultsByChatQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setRiskListResultsByChatData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      cursor?: string | undefined;
      limit?: number | undefined;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: RiskListResultsByChatQueryData,
): RiskListResultsByChatQueryData | undefined {
  const key = queryKeyRiskListResultsByChat(...queryKeyBase);

  return client.setQueryData<RiskListResultsByChatQueryData>(key, data);
}

export function invalidateRiskListResultsByChat(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      cursor?: string | undefined;
      limit?: number | undefined;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "results", "byChat", ...queryKeyBase],
  });
}

export function invalidateAllRiskListResultsByChat(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "results", "byChat"],
  });
}
